import React, { useState, useEffect, useContext, useRef } from "react";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  Checkbox,
  Button,
  TextField,
  Typography,
  IconButton,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";
import { useForm, Controller } from "react-hook-form";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useQuery, useManualQuery, useMutation, ClientContext } from "graphql-hooks";
import AlertDialog from "./AlertDialog.js";
import checkImg from "../assets/icons/check_circle.png";
import { project_url } from "../constants/Data";

import {
  CREATE_TERM_TEMPLATE_MUTATION,
  GET_TERM_TEMPLATE_DATA_BY_NAME,
} from "../graphQL/term_template_qry";

var findAnd = require("find-and");

const useStyles = makeStyles(theme => ({
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    marginTop: 30,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14,
    fontFamily: "Arial",
  },
}));

export default function AddTermTemplateInputDialog({
  title,
  text,
  contentMsg,
  type,
  closeDialog,
  errMsg,
  addDialog,
  doneButton,
}) {
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [errorMsg, setErrorMsg] = useState({
    templateName: "",
    noOfSeats: "",
  });
  const [templateName, setTemplateName] = useState("");
  const [description, setDescription] = useState("");
  const [noOfSeats, setNoOfSeats] = useState(1);

  const [alertMsg, setAlertMsg] = useState([]);
  const navigate = useNavigate();

  let clientId = 1;
  if (localStorage.getItem("clientId")) clientId = localStorage.getItem("clientId");

  const [createTermTemplate] = useMutation(CREATE_TERM_TEMPLATE_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [getTemplateData] = useManualQuery(GET_TERM_TEMPLATE_DATA_BY_NAME, {
    fetchPolicy: "network-only",
  });
  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog();
  };

  const handleNameFieldChange = event => {
    if (event.target.value.trim() !== "")
      setErrorMsg(prevErrorMsg => ({
        ...prevErrorMsg,
        templateName: "",
      }));
    setTemplateName(event.target.value);
  };
  const handleDescriptionFieldChange = event => {
    setDescription(event.target.value);
  };
  const validateNoOfSeats = value => {
    if (parseInt(value) < 1) {
      setErrorMsg(prevErrorMsg => ({
        ...prevErrorMsg,
        noOfSeats: "Enter an integer greater than zero.",
      }));
    } else if (parseInt(value) > 99) {
      setErrorMsg(prevErrorMsg => ({
        ...prevErrorMsg,
        noOfSeats: "Enter an integer less than 99.",
      }));
    } else if (value.toString().trim() === "") {
      setErrorMsg(prevErrorMsg => ({
        ...prevErrorMsg,
        noOfSeats: "No of Seats cannot be blank.",
      }));
    } else {
      setErrorMsg(prevErrorMsg => ({
        ...prevErrorMsg,
        noOfSeats: "",
      }));
      setNoOfSeats(value);
    }
  };

  const handleDone = async () => {
    let submitForm = true;

    if (!templateName || templateName.trim() === "") {
      setErrorMsg(prevErrorMsg => ({
        ...prevErrorMsg,
        templateName: "This is a required field",
      }));
      submitForm = false;
    }

    //check if entered name exist in client or not
    const {
      loading: templateLoading,
      error: templateError,
      data: templateData,
    } = await getTemplateData({
      variables: {
        name: templateName,
        description: description,
        clientId: parseInt(clientId),
        termTemplateId: null,
      },
    });

    if (!templateLoading && templateData && templateData.getTermTemplateDataByName) {
      setErrorMsg(prevErrorMsg => ({
        ...prevErrorMsg,
        templateName: "This name has been exist in client, please enter another name.",
      }));

      submitForm = false;
    }

    if (submitForm) {
      const { data, error } = await createTermTemplate({
        variables: {
          name: templateName,
          description: description,
          clientId: parseInt(clientId),
          noOfSeats: parseInt(noOfSeats),
        },
      });
      if (error) {
        console.log("Error", error, data);
        setAlertMsg({
          title: "Error",
          msg: "Unfortunately an error occurred.",
        });
      } else if (data && data.createTermTemplate) {
        console.log("Success", data.createTermTemplate);
        setAlertMsg({
          title: "Success",
          msg: "New Template has been successfully added.",
        });
        //handleClose();
        navigate(
          `${project_url}/tenant/settings/term_templates/${data.createTermTemplate.termTemplate.termTemplateId}`
        );
      }
    }
  };

  return (
    <div>
      <Dialog
        disablePortal
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "600px",
              height: "490px",
            },
          },
        }}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="alert-dialog-title"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Box mt={1} ml={1}>
            Add Term Template
          </Box>
          {closeDialog ? (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                align: "right",
                color: theme => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <DialogContentText id="alert-dialog-description">
                <TextField
                  fullWidth
                  autoFocus
                  label="Template Name"
                  margin="normal"
                  name="templateName"
                  variant="outlined"
                  id="templateName"
                  value={templateName}
                  onChange={handleNameFieldChange}
                  onKeyDown={e => {
                    e.key === "Enter" && handleDone();
                  }}
                />

                {errorMsg.templateName && (
                  <FormHelperText className={classes.errorStyle} error>
                    {errorMsg.templateName}
                  </FormHelperText>
                )}
              </DialogContentText>
            </Grid>
            
            <Grid item xs={8}>
              <DialogContentText id="alert-dialog-description">
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  label="Description"
                  margin="normal"
                  name="description"
                  variant="outlined"
                  id="description"
                  value={description}
                  onChange={handleDescriptionFieldChange}
                  inputProps={{
                    maxLength: 250,
                  }}
                />
              </DialogContentText>
            </Grid>

            <Grid item xs={5}>
              <DialogContentText id="alert-dialog-description">
                <TextField
                  fullWidth
                  label="No of Seats"
                  margin="normal"
                  name="noOfSeats"
                  type="number"
                  defaultValue={1}
                  variant="outlined"
                  onKeyDown={e => {
                    if (e.keyCode >= 65 && e.keyCode <= 90) {
                      e.preventDefault();
                    }
                  }}
                  onChange={e => validateNoOfSeats(e.target.value)}
                  InputProps={{
                    inputProps: { min: 1, max: 99, pattern: "^[1-9][0-9]?$" },
                  }}
                  id="noOfSeats"
                  helperText={errorMsg.noOfSeats}
                  error={errorMsg.noOfSeats}
                  value={noOfSeats}
                />
              </DialogContentText>
            </Grid>
          </Grid>

          {alertMsg.msg && (
            <AlertDialog
              title={alertMsg.title}
              contentMsg={alertMsg.msg}
              closeDialog={() => setAlertMsg([])}
            />
          )}
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <Box mb={2}>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              style={{ marginRight: 2 }}
              onClick={handleDone}
            >
              Save
            </Button>
            <Button
              variant="text"
              color="primary"
              className={classes.outlinedButtonStyle}
              onClick={handleClose}
            >
              Cancel
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}
